import { MpsRole } from '../models/mps-user.model';

export class MpsRoleHelper {
  static readonly USER = 'USER';
  static readonly ADMIN = 'ADMIN';
  // Rôles portés depuis l'ancien OSER
  static readonly SUPERADMIN = 'SUPERADMIN';
  static readonly SUBSIDIARY_ADMIN = 'SUBSIDIARY_ADMIN';

  // Rôles ayant les droits d'administration globale.
  static readonly ADMIN_ROLES = [MpsRoleHelper.ADMIN, MpsRoleHelper.SUPERADMIN];

  // Rôles attribuables depuis le back-office (miroir de RoleEnum::assignable() côté back).
  // ADMIN et USER sont techniques : USER est attribué à la première connexion EntraID.
  static readonly ASSIGNABLE_ROLES = [MpsRoleHelper.SUPERADMIN, MpsRoleHelper.SUBSIDIARY_ADMIN];

  static getRoles(): MpsRole[] {
    return [
      { id: 1, code: MpsRoleHelper.USER, label: 'User' },
      { id: 2, code: MpsRoleHelper.ADMIN, label: 'Admin' },
    ];
  }

  static findRole(roles: MpsRole[], roleCode: string): MpsRole {
    return roles.find((role: MpsRole) => role.code.toUpperCase() === roleCode.toUpperCase())!;
  }

  static getRoleIdFromCode(roleCode: string): number {
    return MpsRoleHelper.findRole(MpsRoleHelper.getRoles(), roleCode).id;
  }

  static getRoleCodeForTranslation(roleCode: string): string {
    return 'entities.roles.' + roleCode.toLowerCase().replace(/-/g, '_');
  }
}
